export default __webpack_public_path__ + "static/media/right-img.b59f734c.png";